import { mergeMap, catchError, switchMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import React from 'react';
import { of, EMPTY, concat } from 'rxjs';
import { defineMessages, FormattedMessage } from 'react-intl';

import * as Actions from './batches.label-batch-status-modal.actions';
import * as LabelQueApi from '../../label-que/label-que.api';
import { bulkloadFulfillmentPlans } from '../../../store/bulkload/bulkload.actions';
import { NotificationService, NOTIFICATION_TYPE_ERROR } from 'ui-components/services/notification-service';
import { labelBatchListener } from '../../../services/pusher-service/persistent-listeners';
import { labelPurchasePusherRace } from '../../bulk/bulk.label.observables';

const messages = defineMessages({
  errorNotoTitle: {
    description: 'label batch status modal error title',
    defaultMessage: 'Error fetching warnings and errors',
    id: 'VBSdjv',
  },
  errorNotoBody: {
    description: 'label batch status modal error body',
    defaultMessage: 'An error occurred while fetching warnings and errors for the label batch status modal. Please try again.',
    id: 'lqyyUQ',
  },
});

export const getLabelQueBatchWarnAndError = (action$) =>
  action$.pipe(
    ofType(Actions.LABEL_BATCH_STATUS_MODAL_GET_WARNING_AND_ERROR_REQUEST),
    mergeMap((action) => {
      const { batchId } = action;
      return LabelQueApi.getLabelQueBatchWarningAndError(batchId).pipe(
        mergeMap((response) => {
          const { data = [] } = response;
          const fulfillmentPlanIds = data.map((datum) => datum.fulfillmentPlanId);
          return concat(of(Actions.labelBatchStatusModalGetWarningAndErrorSuccess(data)), of(bulkloadFulfillmentPlans(fulfillmentPlanIds)));
        }),
        catchError((error) => of(Actions.labelBatchStatusModalGetWarningAndErrorFailure(error))),
      );
    }),
  );

export const handleGeneralLabelQueExceptionEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.LABEL_BATCH_STATUS_MODAL_GET_WARNING_AND_ERROR_FAILURE),
    mergeMap(() => {
      NotificationService.showNotification({
        title: <FormattedMessage {...messages.errorNotoTitle} />,
        notificationType: NOTIFICATION_TYPE_ERROR,
        dontHide: true,
        content: <FormattedMessage {...messages.errorNotoBody} />,
      });
      return EMPTY;
    }),
  );
};

export const retryBatchForWarnAndErrorEpic = (action$) =>
  action$.pipe(
    ofType(Actions.ON_RETRY_BATCH_IN_LABEL_BATCH_STATUS_MODAL_REQUEST),
    mergeMap((action) => {
      const { batchId } = action;

      const { onStart, onFinish } = labelBatchListener.createSingleJobScopedHandlers();
      return LabelQueApi.retryBatch(batchId).pipe(
        switchMap(() => {
          onStart([batchId]);

          return labelPurchasePusherRace({
            action$,
            labelBatchIds: [batchId],
            onFinish,
          }).pipe(switchMap(() => EMPTY));
        }),
        catchError(() => {
          // TODO: handle error
          return EMPTY;
        }),
      );
    }),
  );
